"use client";

import React from "react";

import { useParams } from "next/navigation";

import { GlobalPathParams } from "~/app/[locale]/types";
import { CombinedButton } from "~/components/combined-button/component";
import { Routes } from "~/constants/request";
import { getLinkUrl } from "~/helpers/locales";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { useProtectedRoutes } from "~/hooks/use-protected-routes/hook";
import { Account24 } from "~/theme/icons/components/account";

interface AccountButtonDesktopProps {
  className?: string;
}

export const AccountButtonDesktop: React.FC<AccountButtonDesktopProps> = ({
  className,
}) => {
  const { goToProfile } = useProtectedRoutes();
  const { locale } = useParams<GlobalPathParams>();

  return (
    <CombinedButton
      href={getLinkUrl(locale, Routes.PROFILE)}
      onClick={goToProfile}
      className={className}
      aria-label="my account"
      {...getTestAutomationProps("profile-link")}
      id="profile-link"
    >
      <Account24 />
    </CombinedButton>
  );
};
